module.exports = __webpack_public_path__ + "audio-cf25216e4d24.m4a";